"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NovaLaunch = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var iframe_1 = require("../iframe/iframe");
var lmnt_service_1 = require("../../services/lmnt.service");
var providers_1 = require("../../providers");
var il_spinner_1 = require("../il-spinner/il-spinner");
var lifecycle_enum_1 = require("../../shared/enums/lifecycle.enum");
function NovaLaunch(_a) {
    var _b;
    var uuid = _a.uuid, sx = _a.sx, _c = _a["aria-label"], ariaLabel = _c === void 0 ? 'nova launch' : _c, onMessage = _a.onMessage, launchConfig = _a.launchConfig;
    // some style
    var someStyle = __assign({ position: 'fixed', width: '100%', height: '100%' }, sx);
    // some element attributes
    var wrapperAttributes = {
        sx: someStyle,
        'aria-label': ariaLabel,
        'data-testid': 'nova-launch',
    };
    // state, context, and dependency injection
    var _d = (0, react_1.useState)({
        url: '',
        current: lifecycle_enum_1.LifecycleEnum.LOADING,
    }), state = _d[0], setState = _d[1];
    var configState = react_1.default.useContext(providers_1.ConfigContext);
    var lmntService = (0, react_1.useMemo)(function () { return new lmnt_service_1.LMNTService(configState.service); }, [configState.service]);
    /**
     * onMessage
     * @param this - the current window
     * @param event - the post message event
     * @returns void
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onPostMessage(event) {
        // only allow certain origin domains
        var p = state.url.split('/'); // p for url parts
        var domain = state.url ? p[0] + '//' + p[2] : '';
        if (domain !== event.origin)
            return;
        // parse data and send up
        var data = JSON.parse(event.data);
        onMessage(data, event);
    }
    /**
     * onLoad
     * @param event - the iframe onload dom event
     * @param iframeRef - iframe dom reference
     * @returns void
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onLoad(event, iframeRef) {
        // do something after iframe load
    }
    // useEffect to prevent unnecessary re-renders
    // - only runs again if the dependencies change
    (0, react_1.useEffect)(function () {
        lmntService
            .createNovaLaunchRequest(uuid, launchConfig)
            .then(function (res) {
            setState({ url: res.headers.location, current: lifecycle_enum_1.LifecycleEnum.SUCCESS });
        })
            .catch(function (err) {
            setState({ url: '', current: lifecycle_enum_1.LifecycleEnum.FAILED });
            console.log(err);
        });
    }, [uuid, lmntService, launchConfig]);
    // post message listener for data from the iframe
    window.addEventListener('message', onPostMessage, false);
    var output = (_b = {},
        _b[lifecycle_enum_1.LifecycleEnum.LOADING] = react_1.default.createElement(il_spinner_1.ILSpinner, null),
        _b[lifecycle_enum_1.LifecycleEnum.SUCCESS] = react_1.default.createElement(iframe_1.Iframe, { url: state.url, onLoad: onLoad }),
        _b[lifecycle_enum_1.LifecycleEnum.FAILED] = 'Failed to load player.',
        _b);
    return react_1.default.createElement(material_1.Box, __assign({}, wrapperAttributes), output[state.current]);
}
exports.NovaLaunch = NovaLaunch;
